/**
 * Created by dx.yang on 2017/2/22.
 */

import KsTableKvmHeader from './c/KsTableKvmHeader';
import KsTableKvmBody from './c/KsTableKvmBody';
import KsPages from '../KsPages/index.vue';
import KsPagesNewStyle from '../KsPagesNewStyle/index.vue';
import TableStore from './c/Store';


import * as resizeDetect from '../../services/detect-element-resize';

export default {
    name: 'KsTableKvm',
    components: {
        KsTableKvmHeader,
        KsTableKvmBody,
        KsPages,
        KsPagesNewStyle
    },
    props: {
        pagination: {
            type: Object,
            default: () => {
                return {
                    enabled: false,
                    current: 1,
                    rowsPerPage: 20
                }
            }
        },
        rows: {
            type: Array,
            default: () => []
        },
        select: {
            type: Object,
            default: () => {}
        },
        search: {
            type: String,
            default: ''
        },
        searchFields: {
            type: Array,
            default: () => []
        },
        checked: {
            type: Array,
            default: () => []
        },
        innerScroll: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        checkedKey: {
            type: String,
            default: ''
        },
        keepChecked: {
            type: Boolean,
            default: false
        }, typePages: {
            type: Object,
            default: ()=> {}
        },
        trClass: {
            type: String,
            default: ''
        },
        disabledCheck: {
            type: Array,
            default: () => []
        },
        disabledClass: {
            type: String,
            default: 'c-tr-disabled'
        },
        filterDisable: {
            type: Boolean,
            default: false
        },
        dragCheck: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        resizeHandler() {
            this.store.commit('tableResize');
        },
        setSearch: _.debounce((me) => {
            me.store.commit('setSearch', me.search, me.searchFields);
        }, 100),
    },

    watch: {
        disabledCheck: {
            immediate: true,
            deep: true,
            handler(val) {
                this.store.commit('disabledCheck', this.disabledCheck)
            }
        },
        checked: {
            immediate: true,
            deep: true,
            handler(val) {
                this.store.commit('checkedList', val);
                this.$emit('checked-change', val);
            }
        },
        rows: {
            immediate: true,
            handler(val) {
                let noChange = _.isEqual(val, this.store.states.rows);
                if (!noChange) {
                    this.store.commit('setRows', val)
                }
            }
        },
        search: {
            immediate: true,
            handler(val) {
                this.setSearch(this);
            }
        },
        searchFields: {
            immediate: true,
            deep: true,
            handler(val) {
                this.setSearch(this);
            }
        },
        paginationOptions: {
            immediate: true,
            deep: true,
            handler() {
                this.store.commit('setPage');
                //this.$emit('page-change',this.paginationOptions);
            }
        },
        loading: {
            immediate: true,
            handler() {
                this.store.commit('setLoading', this.loading);
            }
        },
        'store.states.checkedList': {
            immediate: true,
            deep: true,
            handler() {
                // console.log(this.store.states.checkedList);
                this.$emit('checked-change', this.store.states.checkedList);
            }
        },
        'store.states.currentFilterData': {
            immediate: true,
            deep: true,
            handler(val) {
                if(_.isEmpty(val)) return;
                this.$emit('current-filter', val);
            }
        },
        'store.states.currentSort': {
            immediate: true,
            deep: true,
            handler(val) {
                if(val.state) {
                    this.$emit('current-sort', val);
                }
            }
        }
    },

    mounted() {
        this.$nextTick(() => {
            // ready
            // 绑定resize事件
            resizeDetect.addResizeListener(this.$el, this.resizeHandler)
        });
    },
    beforeDestroy() {
        // 解绑resize事件
        resizeDetect.removeResizeListener(this.$el, this.resizeHandler)
    },

    data() {
        return {
            paginationOptions: {
                enabled: this.pagination.enabled || false,
                current: this.pagination.current || 1,
                totalRows: this.pagination.totalRows || 0,
                rowsPerPage: this.pagination.rowsPerPage || 20
            },
            store: new TableStore(this, {
                loading: this.loading,
                innerScroll: this.innerScroll,
                currentSort: {
                    state: '',
                    field: '',
                    by: ''
                },
                checkedList: this.checked,
                currentFilter: {},
                currentFilterData: {},
                select: this.select,
                trClass: this.trClass,
                disabledCheck: this.disabledCheck,
                disabledClass: this.disabledClass,
                filterDisable: this.filterDisable,
                dragCheck: this.dragCheck
            })
        };
    },
};
